import { useState, useEffect, useMemo } from 'react';
import { Col, Row, Divider, Radio, Space } from 'antd';
import { Helmet } from 'react-helmet';
import MultinationalTabs from '../../../../../../components/MultinationalTabs';
import { useDispatch, useSelector } from 'react-redux';
import {
    getSmsDrivers,
    allSmsDrivers,
} from '../../../../../../redux/slices/settingsSlice';
import {
    oneClient,
    // updateClientDrivers,
    getClient,
    clientDataStore,
    getClientDataStore,
    createClientDataStore,
} from '../../../../../../redux/slices/clientsSlice';
import SmsTypeDriverInputs from './SmsTypeDriverInputs';
import SmsTypeSenderInputs from './SmsTypeSenderInputs';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { countriesOptions } from '../../../../../../shared/data/clientDetailsOptions';
import { createShallowCopy } from '../../../../../../utils/helpFunctions';
import useDataStoreState from '../hooks/useDataStoreState';

export default function SmsTypePage() {
    const dispatch = useDispatch();
    const params = useParams();
    const pushDrivers = useSelector(allSmsDrivers);
    const client = useSelector(oneClient);
    const generalData = useSelector(clientDataStore);

    const [dataStore, setDataStore] = useDataStoreState({
        generalData,
    });

    const countriesLocalizationsData = useMemo(
        () =>
            client?.countries_localizations?.reduce((acc, el) => {
                acc[el.country_code] = el;
                return acc;
            }, {}),
        [client],
    );

    const [excludedCodes, setExcludedCodes] = useState([]);
    const [radioButtonValue, setRadioButtonValue] = useState({
        is_send_sms_if_phone_not_confirmed: 0,
    });
    const [data, setData] = useState({
        countries_localizations: {
            sv: {
                sms_driver_id: null,
                sms_driver_name: '',
                sms_driver_username: '',
                sms_driver_password: '',
                sms_driver_service_url: '',
                sms_sender_name: '',
            },
            no: {
                sms_driver_id: null,
                sms_driver_name: '',
                sms_driver_username: '',
                sms_driver_password: '',
                sms_driver_service_url: '',
                sms_sender_name: '',
            },
            fi: {
                sms_driver_id: null,
                sms_driver_name: '',
                sms_driver_username: '',
                sms_driver_password: '',
                sms_driver_service_url: '',
                sms_sender_name: '',
            },
            da: {
                sms_driver_id: null,
                sms_driver_name: '',
                sms_driver_username: '',
                sms_driver_password: '',
                sms_driver_service_url: '',
                sms_sender_name: '',
            },
            en: {
                sms_driver_id: null,
                sms_driver_name: '',
                sms_driver_username: '',
                sms_driver_password: '',
                sms_driver_service_url: '',
                sms_sender_name: '',
            },
            is: {
                sms_driver_id: null,
                sms_driver_name: '',
                sms_driver_username: '',
                sms_driver_password: '',
                sms_driver_service_url: '',
                sms_sender_name: '',
            },
        },
        is_send_sms_if_phone_not_confirmed: null,
    });

    useEffect(() => {
        if (!!Object.keys(generalData).length) {
            const excludedCodes = countriesOptions
                .filter(
                    (option) =>
                        !generalData?.account_countries?.includes(option.id),
                )
                .map((item) => item.id.toLowerCase());

            setExcludedCodes(excludedCodes);
            setDataStore((prevDataStore) => ({
                ...prevDataStore,
                sms: generalData.sms || prevDataStore.sms,
                email: generalData.email || prevDataStore.email,
            }));
        }
    }, [generalData, setDataStore]);

    useEffect(() => {
        dispatch(getSmsDrivers());
    }, [dispatch]);

    useEffect(() => {
        setData({
            countries_localizations: {
                sv: {
                    sms_driver_id:
                        countriesLocalizationsData?.sv?.sms_driver_id || null,
                    sms_driver_name:
                        countriesLocalizationsData?.sv?.sms_driver_name || '',
                    sms_driver_username:
                        countriesLocalizationsData?.sv?.sms_driver_username ||
                        '',
                    sms_driver_password:
                        countriesLocalizationsData?.sv?.sms_driver_password ||
                        '',
                    sms_driver_service_url:
                        countriesLocalizationsData?.sv
                            ?.sms_driver_service_url || '',
                    sms_sender_name:
                        countriesLocalizationsData?.sv?.sms_sender_name || '',
                },
                no: {
                    sms_driver_id:
                        countriesLocalizationsData?.no?.sms_driver_id || null,
                    sms_driver_name:
                        countriesLocalizationsData?.no?.sms_driver_name || '',
                    sms_driver_username:
                        countriesLocalizationsData?.no?.sms_driver_username ||
                        '',
                    sms_driver_password:
                        countriesLocalizationsData?.no?.sms_driver_password ||
                        '',
                    sms_driver_service_url:
                        countriesLocalizationsData?.no
                            ?.sms_driver_service_url || '',
                    sms_sender_name:
                        countriesLocalizationsData?.no?.sms_sender_name || '',
                },
                fi: {
                    sms_driver_id:
                        countriesLocalizationsData?.fi?.sms_driver_id || null,
                    sms_driver_name:
                        countriesLocalizationsData?.fi?.sms_driver_name || '',
                    sms_driver_username:
                        countriesLocalizationsData?.fi?.sms_driver_username ||
                        '',
                    sms_driver_password:
                        countriesLocalizationsData?.fi?.sms_driver_password ||
                        '',
                    sms_driver_service_url:
                        countriesLocalizationsData?.fi
                            ?.sms_driver_service_url || '',
                    sms_sender_name:
                        countriesLocalizationsData?.fi?.sms_sender_name || '',
                },
                da: {
                    sms_driver_id:
                        countriesLocalizationsData?.da?.sms_driver_id || null,
                    sms_driver_name:
                        countriesLocalizationsData?.da?.sms_driver_name || '',
                    sms_driver_username:
                        countriesLocalizationsData?.da?.sms_driver_username ||
                        '',
                    sms_driver_password:
                        countriesLocalizationsData?.da?.sms_driver_password ||
                        '',
                    sms_driver_service_url:
                        countriesLocalizationsData?.da
                            ?.sms_driver_service_url || '',
                    sms_sender_name:
                        countriesLocalizationsData?.da?.sms_sender_name || '',
                },
                en: {
                    sms_driver_id:
                        countriesLocalizationsData?.en?.sms_driver_id || null,
                    sms_driver_name:
                        countriesLocalizationsData?.en?.sms_driver_name || '',
                    sms_driver_username:
                        countriesLocalizationsData?.en?.sms_driver_username ||
                        '',
                    sms_driver_password:
                        countriesLocalizationsData?.en?.sms_driver_password ||
                        '',
                    sms_driver_service_url:
                        countriesLocalizationsData?.en
                            ?.sms_driver_service_url || '',
                    sms_sender_name:
                        countriesLocalizationsData?.en?.sms_sender_name || '',
                },
                is: {
                    sms_driver_id:
                        countriesLocalizationsData?.is?.sms_driver_id || null,
                    sms_driver_name:
                        countriesLocalizationsData?.is?.sms_driver_name || '',
                    sms_driver_username:
                        countriesLocalizationsData?.is?.sms_driver_username ||
                        '',
                    sms_driver_password:
                        countriesLocalizationsData?.is?.sms_driver_password ||
                        '',
                    sms_driver_service_url:
                        countriesLocalizationsData?.is
                            ?.sms_driver_service_url || '',
                    sms_sender_name:
                        countriesLocalizationsData?.is?.sms_sender_name || '',
                },
            },
            is_send_sms_if_phone_not_confirmed:
                client?.is_send_sms_if_phone_not_confirmed,
        });

        setRadioButtonValue({
            is_send_sms_if_phone_not_confirmed:
                client?.is_send_sms_if_phone_not_confirmed,
        });
    }, [countriesLocalizationsData, client]);

    const onChangeMultinational = (e, flag) => {
        const currentInput = e.target.id.slice(0, e.target.id.length - 3);
        const value = e.target.value;
        const newData = {
            ...data,
            countries_localizations: {
                ...data.countries_localizations,
                [flag]: {
                    ...data.countries_localizations[flag],
                    [currentInput]: value,
                },
            },
        };

        setData(newData);
    };

    const onChangeDataStore = (e, flag) => {
        const currentInput = e.target.id.slice(0, e.target.id.length - 3);
        const value = e.target.value;
        const dataStoreCopy = createShallowCopy(dataStore);

        dataStoreCopy.sms[flag][currentInput] = value;
        setDataStore(dataStoreCopy);
    };

    const onSelectChange = (option, flag) => {
        const optionId = option.id;

        const newData = {
            ...data,
            countries_localizations: {
                ...data.countries_localizations,
                [flag]: {
                    ...data.countries_localizations[flag],
                    sms_driver_id: optionId,
                    sms_driver_host: '',
                    sms_driver_username: '',
                    sms_driver_password: '',
                },
            },
        };

        setData(newData);
    };

    const onRadioButtonsChange = (e) => {
        setRadioButtonValue({
            ...radioButtonValue,
            [e.target.name]: e.target.value,
        });
        setData({
            ...data,
            [e.target.name]: e.target.value,
        });
    };

    const onSubmit = async (e) => {
        e.preventDefault();

        const fields = [];
        Object.keys(dataStore).forEach((key) => {
            const value = dataStore[key];
            if (value !== undefined) {
                fields.push({ key_name: key, value });
            }
        });
        const bodyDataStore = { fields };

        try {
            // await dispatch(
            //     updateClientDrivers({ id: params.id, body: data }),
            // ).unwrap();

            if (Object.keys(bodyDataStore.fields).length !== 0) {
                await dispatch(
                    createClientDataStore({
                        id: client.client_uid,
                        body: bodyDataStore,
                        collectionName: 'clients',
                    }),
                ).unwrap();
                await dispatch(
                    getClientDataStore({
                        id: client.client_uid,
                        collectionName: 'clients',
                    }),
                ).unwrap();
            }

            dispatch(getClient(params.id));
            toast.success('Changes saved successfully');
        } catch (error) {
            toast.error(error.errors);
        }
    };

    const selectOptions = pushDrivers?.reduce(
        (acc, el) => {
            acc.push({
                id: el.id,
                value: el.name.toLowerCase(),
                label: el.name,
            });
            return acc;
        },
        [
            {
                id: null,
                value: 'sms_driver_id',
                label: 'Custom driver',
            },
        ],
    );

    return (
        <>
            <Helmet>
                <title>{`Console Defentry - Clients - ${client.name} - Notifications - SMS`}</title>
            </Helmet>
            <Row>
                <Col span={10}>
                    <form>
                        <p className="form__input-group-header">
                            CURRENT DRIVER
                        </p>
                        <MultinationalTabs
                            codeType="countries"
                            excludedCodes={excludedCodes}
                        >
                            <SmsTypeDriverInputs
                                onChange={onChangeMultinational}
                                onSelectChange={onSelectChange}
                                data={data.countries_localizations}
                                selectOptions={selectOptions}
                            />
                        </MultinationalTabs>
                        <Divider />
                        <p className="form__input-group-header">SENDER</p>
                        <MultinationalTabs
                            codeType="countries"
                            excludedCodes={excludedCodes}
                        >
                            <SmsTypeSenderInputs
                                onChange={onChangeMultinational}
                                onChangeDataStore={onChangeDataStore}
                                data={dataStore.sms}
                            />
                        </MultinationalTabs>
                        <Divider />
                        <div className="form__item-wrapper--column">
                            <p className="input-label">Send welcome b2c SMS</p>
                            <Radio.Group
                                onChange={onRadioButtonsChange}
                                value={
                                    radioButtonValue.is_send_sms_if_phone_not_confirmed
                                }
                                name="is_send_sms_if_phone_not_confirmed"
                            >
                                <Space direction="vertical">
                                    <Radio value={1}>Yes</Radio>
                                    <Radio value={0}>No</Radio>
                                </Space>
                            </Radio.Group>
                        </div>
                        <div className="form__footer">
                            <button
                                className="modal__button modal__button-accept"
                                type="button"
                                onClick={onSubmit}
                            >
                                Save
                            </button>
                        </div>
                    </form>
                </Col>
            </Row>
        </>
    );
}
